var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26663 13.8519C10.9681 13.8519 13.9688 10.9749 13.9688 7.42593C13.9688 3.87699 10.9681 1 7.26663 1C3.56512 1 0.564453 3.87699 0.564453 7.42593C0.564453 10.9749 3.56512 13.8519 7.26663 13.8519Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.564453 7.4259H13.9688",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26657 1C8.94297 2.75965 9.89566 5.04322 9.94744 7.42593C9.89566 9.80865 8.94297 12.0922 7.26657 13.8519C5.59016 12.0922 4.63747 9.80865 4.58569 7.42593C4.63747 5.04322 5.59016 2.75965 7.26657 1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobal);
export default __webpack_public_path__ + "static/media/icon_global.3dee3d96dea0e08b95e47fcd18bfba49.svg";
export { ForwardRef as ReactComponent };